export class CadastreImportModel {
  url: string;
  password: string;
  userName: string;
  folder: string;
  vfkVersion: string | number;
  cadastreCodes?: string;
  kuIdsToDownload?: string;
}
